import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import PrivacyPolicyView from '../views/PrivacyPolicy.vue'
import TnCView from '../views/TnC.vue'
import FeedbackView from '../views/FeedbackView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/privacy_policy',
    name: 'privacy',
    component: PrivacyPolicyView
  },
  {
    path: '/terms_conditions',
    name: 'TnC',
    component: TnCView
  },
  {
    path: '/feedback',
    name: 'FeedbackView',
    component: FeedbackView
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
